import React, {forwardRef, useId} from 'react'
import {Box, chakra} from '@chakra-ui/react3'
import PropTypes from 'prop-types'

import _3dRotateFilledSymbol from '../../assets/svg/3d-rotate-filled.svg'
import _3dRotateSymbol from '../../assets/svg/3d-rotate.svg'
import _3DViewSymbol from '../../assets/svg/3-d-view.svg'
import AddSymbol from '../../assets/svg/add.svg'
import ArrowDownSymbol from '../../assets/svg/arrow-down.svg'
import ArrowLeftSymbol from '../../assets/svg/arrow-left-leap.svg'
import ArrowReloadHorizontalSymbol from '../../assets/svg/arrow-reload-horizontal.svg'
import ArrowRightSymbol from '../../assets/svg/arrow-right-leap.svg'
import ArrowTurnBackwardSymbol from '../../assets/svg/arrow-turn-backward.svg'
import ArrowUpSymbol from '../../assets/svg/arrow-up.svg'
import BookmarkAddFilledSymbol from '../../assets/svg/bookmark-add-filled.svg'
import BookmarkAddSymbol from '../../assets/svg/bookmark-add.svg'
import BookmarkFilledSymbol from '../../assets/svg/bookmark-filled.svg'
import BookmarkSymbol from '../../assets/svg/bookmark.svg'
import BookOpenSymbol from '../../assets/svg/book-open.svg'
import BubbleChatSymbol from '../../assets/svg/bubble-chat.svg'
import BubbleChatQuestionSymbol from '../../assets/svg/bubble-chat-question.svg'
import CalendarFilledSymbol from '../../assets/svg/calendar-filled.svg'
import CalendarSymbol from '../../assets/svg/calendar.svg'
import CancelSymbol from '../../assets/svg/cancel.svg'
import CheckSymbol from '../../assets/svg/check.svg'
import CheckmarkBadgeFilledSymbol from '../../assets/svg/checkmark-badge-filled.svg'
import CheckmarkBadgeSymbol from '../../assets/svg/checkmark-badge.svg'
import CheckmarkCircleFilledSymbol from '../../assets/svg/checkmark-circle-filled.svg'
import CheckmarkCircleSymbol from '../../assets/svg/checkmark-circle.svg'
import ChevronDownSymbol from '../../assets/svg/chevron-down-leap.svg'
import ChevronLeftSymbol from '../../assets/svg/chevron-left-leap.svg'
import ChevronRightSymbol from '../../assets/svg/chevron-right-leap.svg'
import ChevronUpSymbol from '../../assets/svg/chevron-up-leap.svg'
import ClockFilledSymbol from '../../assets/svg/clock-filled.svg'
import ClockSymbol from '../../assets/svg/clock.svg'
import CopyFilledSymbol from '../../assets/svg/copy-filled.svg'
import CopySymbol from '../../assets/svg/copy.svg'
import CreditCardSymbol from '../../assets/svg/credit-card.svg'
import VisaSymbol from '../../assets/svg/cc-visa.svg'
import DashboardSquareFilledSymbol from '../../assets/svg/dashboard-square-filled.svg'
import DashboardSquareSymbol from '../../assets/svg/dashboard-square.svg'
import DeleteFilledSymbol from '../../assets/svg/delete-filled.svg'
import DeleteSymbol from '../../assets/svg/delete-leap.svg'
import DeliveryTruckFilledSymbol from '../../assets/svg/delivery-truck-02-filled.svg'
import DeliveryTruckSymbol from '../../assets/svg/delivery-truck-02.svg'
import DocumentValidationFilledSymbol from '../../assets/svg/document-validation-filled.svg'
import DocumentValidationSymbol from '../../assets/svg/document-validation.svg'
import DownloadSymbol from '../../assets/svg/download.svg'
import EyeSymbol from '../../assets/svg/eye.svg'
import FavoriteFilledSymbol from '../../assets/svg/favorite-filled.svg'
import FavoriteSymbol from '../../assets/svg/favorite.svg'
import FilterHorizontalFilledSymbol from '../../assets/svg/filter-horizontal-filled.svg'
import FilterHorizontalSymbol from '../../assets/svg/filter-horizontal.svg'
import Gift2Symbol from '../../assets/svg/gift2.svg'
import GlobeSymbol from '../../assets/svg/globe.svg'
import GpsSymbol from '../../assets/svg/gps.svg'
import HeadsetSymbol from '../../assets/svg/headset.svg'
import HourglassFilledSymbol from '../../assets/svg/hourglass-filled.svg'
import HourglassSymbol from '../../assets/svg/hourglass.svg'
import InformationCircleSymbol from '../../assets/svg/information-circle.svg'
import InformationCircleFilledSymbol from '../../assets/svg/information-circle-filled.svg'
import LocationFilledSymbol from '../../assets/svg/location-filled.svg'
import LocationSymbol from '../../assets/svg/location-leap.svg'
import LoginSymbol from '../../assets/svg/login.svg'
import LogoutSymbol from '../../assets/svg/logout-leap.svg'
import Notification01Symbol from '../../assets/svg/notification-01.svg'
import PaintBoardSymbol from '../../assets/svg/paint-board.svg'
import PauseSymbol from '../../assets/svg/pause.svg'
import PenFilledSymbol from '../../assets/svg/pen-filled.svg'
import PenSymbol from '../../assets/svg/pen.svg'
import PlaySymbol from '../../assets/svg/play-leap.svg'
import RemoveSymbol from '../../assets/svg/remove.svg'
import ResourcesAddSymbol from '../../assets/svg/resources-add.svg'
import Rotate360Symbol from '../../assets/svg/rotate360.svg'
import SearchAddSymbol from '../../assets/svg/search-add.svg'
import SearchMinusSymbol from '../../assets/svg/search-minus.svg'
import SearchSymbol from '../../assets/svg/search.svg'
import SecurityValidationFilledSymbol from '../../assets/svg/security-validation-filled.svg'
import SecurityValidationSymbol from '../../assets/svg/security-validation.svg'
import SettingsFilledSymbol from '../../assets/svg/settings-filled.svg'
import SettingsSymbol from '../../assets/svg/settings.svg'
import ShoppingCartSymbol from '../../assets/svg/shopping-cart.svg'
import SortByDownSymbol from '../../assets/svg/sort-by-down.svg'
import SortByUpSymbol from '../../assets/svg/sort-by-up.svg'
import StarFilledSymbol from '../../assets/svg/star-filled.svg'
import StarSymbol from '../../assets/svg/star.svg'
import StopWatchFilledSymbol from '../../assets/svg/stop-watch-filled.svg'
import StopWatchSymbol from '../../assets/svg/stop-watch.svg'
import TextCircleSymbol from '../../assets/svg/text-circle.svg'
import TokenCircleFilledSymbol from '../../assets/svg/token-circle-filled.svg'
import TokenCircleSymbol from '../../assets/svg/token-circle.svg'
import TrippTrappSymbol from '../../assets/svg/tripp-trapp.svg'
import UserFilledSymbol from '../../assets/svg/user-filled.svg'
import UserSymbol from '../../assets/svg/user-leap.svg'
import VideoSymbol from '../../assets/svg/video.svg'
import WarningSymbol from '../../assets/svg/warning.svg'

_3dRotateFilledSymbol.viewBox = _3dRotateFilledSymbol.viewBox || '0 0 24 24'
_3dRotateSymbol.viewBox = _3dRotateSymbol.viewBox || '0 0 24 24'
_3DViewSymbol.viewBox = _3DViewSymbol.viewBox || '0 0 20 20'
AddSymbol.viewBox = AddSymbol.viewBox || '0 0 24 24'
ArrowDownSymbol.viewBox = ArrowDownSymbol.viewBox || '0 0 24 24'
ArrowLeftSymbol.viewBox = ArrowLeftSymbol.viewBox || '0 0 24 24'
ArrowReloadHorizontalSymbol.viewBox = ArrowReloadHorizontalSymbol.viewBox || '0 0 24 24'
ArrowRightSymbol.viewBox = ArrowRightSymbol.viewBox || '0 0 24 24'
ArrowTurnBackwardSymbol.viewBox = ArrowTurnBackwardSymbol.viewBox || '0 0 24 24'
ArrowUpSymbol.viewBox = ArrowUpSymbol.viewBox || '0 0 24 24'
BookmarkAddFilledSymbol.viewBox = BookmarkAddFilledSymbol.viewBox || '0 0 24 24'
BookmarkAddSymbol.viewBox = BookmarkAddSymbol.viewBox || '0 0 24 24'
BookmarkFilledSymbol.viewBox = BookmarkFilledSymbol.viewBox || '0 0 24 24'
BookmarkSymbol.viewBox = BookmarkSymbol.viewBox || '0 0 24 24'
BookOpenSymbol.viewBox = BookOpenSymbol.viewBox || '0 0 24 24'
BubbleChatSymbol.viewBox = BubbleChatSymbol.viewBox || '0 0 24 24'
BubbleChatQuestionSymbol.viewBox = BubbleChatQuestionSymbol.viewBox || '0 0 24 24'
CalendarFilledSymbol.viewBox = CalendarFilledSymbol.viewBox || '0 0 24 24'
CalendarSymbol.viewBox = CalendarSymbol.viewBox || '0 0 24 24'
CancelSymbol.viewBox = CancelSymbol.viewBox || '0 0 24 24'
CheckSymbol.viewBox = CheckSymbol.viewBox || '0 0 24 24'
CheckmarkBadgeFilledSymbol.viewBox = CheckmarkBadgeFilledSymbol.viewBox || '0 0 24 24'
CheckmarkBadgeSymbol.viewBox = CheckmarkBadgeSymbol.viewBox || '0 0 24 24'
CheckmarkCircleFilledSymbol.viewBox = CheckmarkCircleFilledSymbol.viewBox || '0 0 24 24'
CheckmarkCircleSymbol.viewBox = CheckmarkCircleSymbol.viewBox || '0 0 24 24'
ChevronDownSymbol.viewBox = ChevronDownSymbol.viewBox || '0 0 24 24'
ChevronLeftSymbol.viewBox = ChevronLeftSymbol.viewBox || '0 0 24 24'
ChevronRightSymbol.viewBox = ChevronRightSymbol.viewBox || '0 0 24 24'
ChevronUpSymbol.viewBox = ChevronUpSymbol.viewBox || '0 0 24 24'
ClockFilledSymbol.viewBox = ClockFilledSymbol.viewBox || '0 0 24 24'
ClockSymbol.viewBox = ClockSymbol.viewBox || '0 0 24 24'
CopyFilledSymbol.viewBox = CopyFilledSymbol.viewBox || '0 0 24 24'
CopySymbol.viewBox = CopySymbol.viewBox || '0 0 24 24'
CreditCardSymbol.viewBox = CreditCardSymbol.viewBox || '0 0 24 24'
VisaSymbol.viewBox = VisaSymbol.viewBox || '0 0 46 32'
DashboardSquareFilledSymbol.viewBox = DashboardSquareFilledSymbol.viewBox || '0 0 24 24'
DashboardSquareSymbol.viewBox = DashboardSquareSymbol.viewBox || '0 0 24 24'
DeleteFilledSymbol.viewBox = DeleteFilledSymbol.viewBox || '0 0 24 24'
DeleteSymbol.viewBox = DeleteSymbol.viewBox || '0 0 24 24'
DeliveryTruckFilledSymbol.viewBox = DeliveryTruckFilledSymbol.viewBox || '0 0 24 24'
DeliveryTruckSymbol.viewBox = DeliveryTruckSymbol.viewBox || '0 0 24 24'
DocumentValidationFilledSymbol.viewBox = DocumentValidationFilledSymbol.viewBox || '0 0 24 24'
DocumentValidationSymbol.viewBox = DocumentValidationSymbol.viewBox || '0 0 24 24'
DownloadSymbol.viewBox = DownloadSymbol.viewBox || '0 0 24 24'
EyeSymbol.viewBox = EyeSymbol.viewBox || '0 0 16 16'
FavoriteFilledSymbol.viewBox = FavoriteFilledSymbol.viewBox || '0 0 24 24'
FavoriteSymbol.viewBox = FavoriteSymbol.viewBox || '0 0 24 24'
FilterHorizontalFilledSymbol.viewBox = FilterHorizontalFilledSymbol.viewBox || '0 0 24 24'
FilterHorizontalSymbol.viewBox = FilterHorizontalSymbol.viewBox || '0 0 24 24'
Gift2Symbol.viewBox = Gift2Symbol.viewBox || '0 0 24 24'
GlobeSymbol.viewBox = GlobeSymbol.viewBox || '0 0 24 24'
GpsSymbol.viewBox = GpsSymbol.viewBox || '0 0 24 24'
HeadsetSymbol.viewBox = HeadsetSymbol.viewBox || '0 0 24 24'
HourglassFilledSymbol.viewBox = HourglassFilledSymbol.viewBox || '0 0 24 24'
HourglassSymbol.viewBox = HourglassSymbol.viewBox || '0 0 24 24'
InformationCircleSymbol.viewBox = InformationCircleSymbol.viewBox || '0 0 24 24'
InformationCircleFilledSymbol.viewBox = InformationCircleFilledSymbol.viewBox || '0 0 24 24'
LocationFilledSymbol.viewBox = LocationFilledSymbol.viewBox || '0 0 24 24'
LocationSymbol.viewBox = LocationSymbol.viewBox || '0 0 24 24'
LoginSymbol.viewBox = LoginSymbol.viewBox || '0 0 24 24'
LogoutSymbol.viewBox = LogoutSymbol.viewBox || '0 0 24 24'
Notification01Symbol.viewBox = Notification01Symbol.viewBox || '0 0 24 24'
PaintBoardSymbol.viewBox = PaintBoardSymbol.viewBox || '0 0 16 16'
PauseSymbol.viewBox = PauseSymbol.viewBox || '0 0 24 24'
PenFilledSymbol.viewBox = PenFilledSymbol.viewBox || '0 0 24 24'
PenSymbol.viewBox = PenSymbol.viewBox || '0 0 24 24'
PlaySymbol.viewBox = PlaySymbol.viewBox || '0 0 24 24'
RemoveSymbol.viewBox = RemoveSymbol.viewBox || '0 0 24 24'
ResourcesAddSymbol.viewBox = ResourcesAddSymbol.viewBox || '0 0 16 16'
Rotate360Symbol.viewBox = Rotate360Symbol.viewBox || '0 0 24 24'
SearchAddSymbol.viewBox = SearchAddSymbol.viewBox || '0 0 24 24'
SearchMinusSymbol.viewBox = SearchMinusSymbol.viewBox || '0 0 24 24'
SearchSymbol.viewBox = SearchSymbol.viewBox || '0 0 24 24'
SecurityValidationFilledSymbol.viewBox = SecurityValidationFilledSymbol.viewBox || '0 0 24 24'
SecurityValidationSymbol.viewBox = SecurityValidationSymbol.viewBox || '0 0 24 24'
SettingsFilledSymbol.viewBox = SettingsFilledSymbol.viewBox || '0 0 24 24'
SettingsSymbol.viewBox = SettingsSymbol.viewBox || '0 0 24 24'
ShoppingCartSymbol.viewBox = ShoppingCartSymbol.viewBox || '0 0 24 24'
SortByDownSymbol.viewBox = SortByDownSymbol.viewBox || '0 0 24 24'
SortByUpSymbol.viewBox = SortByUpSymbol.viewBox || '0 0 24 24'
StarFilledSymbol.viewBox = StarFilledSymbol.viewBox || '0 0 24 24'
StarSymbol.viewBox = StarSymbol.viewBox || '0 0 24 24'
StopWatchFilledSymbol.viewBox = StopWatchFilledSymbol.viewBox || '0 0 24 24'
StopWatchSymbol.viewBox = StopWatchSymbol.viewBox || '0 0 24 24'
TextCircleSymbol.viewBox = TextCircleSymbol.viewBox || '0 0 16 16'
TokenCircleFilledSymbol.viewBox = TokenCircleFilledSymbol.viewBox || '0 0 24 24'
TokenCircleSymbol.viewBox = TokenCircleSymbol.viewBox || '0 0 24 24'
TrippTrappSymbol.viewBox = TrippTrappSymbol.viewBox || '0 0 24 24'
UserFilledSymbol.viewBox = UserFilledSymbol.viewBox || '0 0 24 24'
UserSymbol.viewBox = UserSymbol.viewBox || '0 0 24 24'
VideoSymbol.viewBox = VideoSymbol.viewBox || '0 0 24 24'
WarningSymbol.viewBox = WarningSymbol.viewBox || '0 0 16 16'

const Svg = chakra('svg', {})

function makeSpriteIcon(name, extras = {}) {
    const {viewBox = '0 0 24 24', role = 'img'} = extras

    const SpriteIcon = forwardRef((props, ref) => {
        const {'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, ...rest} = props
        const titleId = useId()

        const a11y = ariaLabel
            ? {'aria-labelledby': titleId}
            : ariaLabelledby
            ? {'aria-labelledby': ariaLabelledby}
            : {'aria-hidden': true}

        return (
            <Svg ref={ref} viewBox={viewBox} role={role} focusable="false" {...a11y} {...rest}>
                {ariaLabel && <title id={titleId}>{ariaLabel}</title>}
                <use href={`#leap-${name}`} xlinkHref={`#leap-${name}`} />
            </Svg>
        )
    })

    SpriteIcon.displayName = `${name
        .replace(/(^|[-_ ])\w/g, (m) => m.toUpperCase())
        .replace(/[-_ ]/g, '')}Icon`

    SpriteIcon.propTypes = {
        'aria-label': PropTypes.string,
        'aria-labelledby': PropTypes.string
    }

    return SpriteIcon
}

// Exports (alphabetisch)
export const _3dRotateFilledIcon = makeSpriteIcon('3d-rotate-filled', {
    viewBox: _3dRotateFilledSymbol.viewBox
})
export const _3dRotateIcon = makeSpriteIcon('3d-rotate', {viewBox: _3dRotateSymbol.viewBox})
export const _3DViewIcon = makeSpriteIcon('3-d-view', {viewBox: _3DViewSymbol.viewBox})
export const AddIcon = makeSpriteIcon('add', {viewBox: AddSymbol.viewBox})
export const ArrowDownIcon = makeSpriteIcon('arrow-down', {viewBox: ArrowDownSymbol.viewBox})
export const ArrowLeftIcon = makeSpriteIcon('arrow-left-leap', {viewBox: ArrowLeftSymbol.viewBox})
export const ArrowReloadHorizontalIcon = makeSpriteIcon('arrow-reload-horizontal', {
    viewBox: ArrowReloadHorizontalSymbol.viewBox
})
export const ArrowRightIcon = makeSpriteIcon('arrow-right-leap', {
    viewBox: ArrowRightSymbol.viewBox
})
export const ArrowTurnBackwardIcon = makeSpriteIcon('arrow-turn-backward', {
    viewBox: ArrowTurnBackwardSymbol.viewBox
})
export const ArrowUpIcon = makeSpriteIcon('arrow-up', {viewBox: ArrowUpSymbol.viewBox})
export const BookmarkAddFilledIcon = makeSpriteIcon('bookmark-add-filled', {
    viewBox: BookmarkAddFilledSymbol.viewBox
})
export const BookmarkAddIcon = makeSpriteIcon('bookmark-add', {viewBox: BookmarkAddSymbol.viewBox})
export const BookmarkFilledIcon = makeSpriteIcon('bookmark-filled', {
    viewBox: BookmarkFilledSymbol.viewBox
})
export const BookmarkIcon = makeSpriteIcon('bookmark', {viewBox: BookmarkSymbol.viewBox})
export const BookOpenIcon = makeSpriteIcon('book-open', {viewBox: BookOpenSymbol.viewBox})
export const BubbleChatIcon = makeSpriteIcon('bubble-chat', {viewBox: BubbleChatSymbol.viewBox})
export const BubbleChatQuestionIcon = makeSpriteIcon('bubble-chat-question', {
    viewBox: BubbleChatQuestionSymbol.viewBox
})
export const CalendarFilledIcon = makeSpriteIcon('calendar-filled', {
    viewBox: CalendarFilledSymbol.viewBox
})
export const CalendarIcon = makeSpriteIcon('calendar', {viewBox: CalendarSymbol.viewBox})
export const CancelIcon = makeSpriteIcon('cancel', {viewBox: CancelSymbol.viewBox})
export const CheckIcon = makeSpriteIcon('check', {viewBox: CheckSymbol.viewBox})
export const CheckmarkBadgeFilledIcon = makeSpriteIcon('checkmark-badge-filled', {
    viewBox: CheckmarkBadgeFilledSymbol.viewBox
})
export const CheckmarkBadgeIcon = makeSpriteIcon('checkmark-badge', {
    viewBox: CheckmarkBadgeSymbol.viewBox
})
export const CheckmarkCircleFilledIcon = makeSpriteIcon('checkmark-circle-filled', {
    viewBox: CheckmarkCircleFilledSymbol.viewBox
})
export const CheckmarkCircleIcon = makeSpriteIcon('checkmark-circle', {
    viewBox: CheckmarkCircleSymbol.viewBox
})
export const ChevronDownIcon = makeSpriteIcon('chevron-down-leap', {
    viewBox: ChevronDownSymbol.viewBox
})
export const ChevronLeftIcon = makeSpriteIcon('chevron-left-leap', {
    viewBox: ChevronLeftSymbol.viewBox
})
export const ChevronRightIcon = makeSpriteIcon('chevron-right-leap', {
    viewBox: ChevronRightSymbol.viewBox
})
export const ChevronUpIcon = makeSpriteIcon('chevron-up-leap', {viewBox: ChevronUpSymbol.viewBox})
export const ClockFilledIcon = makeSpriteIcon('clock-filled', {viewBox: ClockFilledSymbol.viewBox})
export const ClockIcon = makeSpriteIcon('clock', {viewBox: ClockSymbol.viewBox})
export const CopyFilledIcon = makeSpriteIcon('copy-filled', {viewBox: CopyFilledSymbol.viewBox})
export const CopyIcon = makeSpriteIcon('copy', {viewBox: CopySymbol.viewBox})
export const CreditCardIcon = makeSpriteIcon('credit-card', {viewBox: CreditCardSymbol.viewBox})
export const VisaIcon = makeSpriteIcon('cc-visa', {viewBox: VisaSymbol.viewBox})
export const DashboardSquareFilledIcon = makeSpriteIcon('dashboard-square-filled', {
    viewBox: DashboardSquareFilledSymbol.viewBox
})
export const DashboardSquareIcon = makeSpriteIcon('dashboard-square', {
    viewBox: DashboardSquareSymbol.viewBox
})
export const DeleteFilledIcon = makeSpriteIcon('delete-filled', {
    viewBox: DeleteFilledSymbol.viewBox
})
export const DeleteIcon = makeSpriteIcon('delete-leap', {viewBox: DeleteSymbol.viewBox})
export const DeliveryTruckFilledIcon = makeSpriteIcon('delivery-truck-02-filled', {
    viewBox: DeliveryTruckFilledSymbol.viewBox
})
export const DeliveryTruckIcon = makeSpriteIcon('delivery-truck-02', {
    viewBox: DeliveryTruckSymbol.viewBox
})
export const DocumentValidationFilledIcon = makeSpriteIcon('document-validation-filled', {
    viewBox: DocumentValidationFilledSymbol.viewBox
})
export const DocumentValidationIcon = makeSpriteIcon('document-validation', {
    viewBox: DocumentValidationSymbol.viewBox
})
export const DownloadIcon = makeSpriteIcon('download', {viewBox: DownloadSymbol.viewBox})
export const EyeIcon = makeSpriteIcon('eye', {viewBox: EyeSymbol.viewBox})
export const FavoriteFilledIcon = makeSpriteIcon('favorite-filled', {
    viewBox: FavoriteFilledSymbol.viewBox
})
export const FavoriteIcon = makeSpriteIcon('favorite', {viewBox: FavoriteSymbol.viewBox})
export const FilterHorizontalFilledIcon = makeSpriteIcon('filter-horizontal-filled', {
    viewBox: FilterHorizontalFilledSymbol.viewBox
})
export const FilterHorizontalIcon = makeSpriteIcon('filter-horizontal', {
    viewBox: FilterHorizontalSymbol.viewBox
})
export const Gift2Icon = makeSpriteIcon('gift2', {viewBox: Gift2Symbol.viewBox})
export const GlobeIcon = makeSpriteIcon('globe', {viewBox: GlobeSymbol.viewBox})
export const GpsIcon = makeSpriteIcon('gps', {viewBox: GpsSymbol.viewBox})
export const HeadsetIcon = makeSpriteIcon('headset', {viewBox: HeadsetSymbol.viewBox})
export const HourglassFilledIcon = makeSpriteIcon('hourglass-filled', {
    viewBox: HourglassFilledSymbol.viewBox
})
export const HourglassIcon = makeSpriteIcon('hourglass', {viewBox: HourglassSymbol.viewBox})
export const InformationCircleIcon = makeSpriteIcon('information-circle', {
    viewBox: InformationCircleSymbol.viewBox
})
export const InformationCircleFilledIcon = makeSpriteIcon('information-circle-filled', {
    viewBox: InformationCircleFilledSymbol.viewBox
})
export const LocationFilledIcon = makeSpriteIcon('location-filled', {
    viewBox: LocationFilledSymbol.viewBox
})
export const LocationIcon = makeSpriteIcon('location-leap', {viewBox: LocationSymbol.viewBox})
export const LoginIcon = makeSpriteIcon('login', {viewBox: LoginSymbol.viewBox})
export const LogoutIcon = makeSpriteIcon('logout-leap', {viewBox: LogoutSymbol.viewBox})
export const MultiColorIcon = forwardRef(({className, css, ...props}, ref) => {
    const iconClassName = ['icon', className].filter(Boolean).join(' ')

    return (
        <Box
            ref={ref}
            role="presentation"
            className={iconClassName}
            {...props}
            css={[
                {
                    display: 'inline-block',
                    borderRadius: 'round',
                    backgroundImage:
                        'conic-gradient(from 180deg at 50% 50%, #FFA604 0deg, #FF4F45 72deg, #BA5DD2 144deg, #1299F5 216deg, #51CC26 288deg, #FFD203 360deg)',
                    backgroundColor: '#B0B0B2'
                },
                css
            ]}
        />
    )
})

MultiColorIcon.propTypes = {
    className: PropTypes.string,
    css: PropTypes.object
}

if (process.env.NODE_ENV !== 'production') {
    MultiColorIcon.displayName = 'MultiColorIcon'
}

export const Notification01Icon = makeSpriteIcon('notification-01', {
    viewBox: Notification01Symbol.viewBox
})
export const PaintBoardIcon = makeSpriteIcon('paint-board', {viewBox: PaintBoardSymbol.viewBox})
export const PauseIcon = makeSpriteIcon('pause', {viewBox: PauseSymbol.viewBox})
export const PenFilledIcon = makeSpriteIcon('pen-filled', {viewBox: PenFilledSymbol.viewBox})
export const PenIcon = makeSpriteIcon('pen', {viewBox: PenSymbol.viewBox})
export const PlayIcon = makeSpriteIcon('play-leap', {viewBox: PlaySymbol.viewBox})
export const RemoveIcon = makeSpriteIcon('remove', {viewBox: RemoveSymbol.viewBox})
export const ResourcesAddIcon = makeSpriteIcon('resources-add', {
    viewBox: ResourcesAddSymbol.viewBox
})
export const Rotate360Icon = makeSpriteIcon('rotate360', {viewBox: Rotate360Symbol.viewBox})
export const SearchAddIcon = makeSpriteIcon('search-add', {viewBox: SearchAddSymbol.viewBox})
export const SearchIcon = makeSpriteIcon('search', {viewBox: SearchSymbol.viewBox})
export const SearchMinusIcon = makeSpriteIcon('search-minus', {viewBox: SearchMinusSymbol.viewBox})
export const SecurityValidationFilledIcon = makeSpriteIcon('security-validation-filled', {
    viewBox: SecurityValidationFilledSymbol.viewBox
})
export const SecurityValidationIcon = makeSpriteIcon('security-validation', {
    viewBox: SecurityValidationSymbol.viewBox
})
export const SettingsFilledIcon = makeSpriteIcon('settings-filled', {
    viewBox: SettingsFilledSymbol.viewBox
})
export const SettingsIcon = makeSpriteIcon('settings', {viewBox: SettingsSymbol.viewBox})
export const ShoppingCartIcon = makeSpriteIcon('shopping-cart', {
    viewBox: ShoppingCartSymbol.viewBox
})
export const SortByDownIcon = makeSpriteIcon('sort-by-down', {viewBox: SortByDownSymbol.viewBox})
export const SortByUpIcon = makeSpriteIcon('sort-by-up', {viewBox: SortByUpSymbol.viewBox})
export const StarFilledIcon = makeSpriteIcon('star-filled', {viewBox: StarFilledSymbol.viewBox})
export const StarIcon = makeSpriteIcon('star', {viewBox: StarSymbol.viewBox})
export const StopWatchFilledIcon = makeSpriteIcon('stop-watch-filled', {
    viewBox: StopWatchFilledSymbol.viewBox
})
export const StopWatchIcon = makeSpriteIcon('stop-watch', {viewBox: StopWatchSymbol.viewBox})
export const TextCircleIcon = makeSpriteIcon('text-circle', {viewBox: TextCircleSymbol.viewBox})
export const TokenCircleFilledIcon = makeSpriteIcon('token-circle-filled', {
    viewBox: TokenCircleFilledSymbol.viewBox
})
export const TokenCircleIcon = makeSpriteIcon('token-circle', {viewBox: TokenCircleSymbol.viewBox})
export const TrippTrappIcon = makeSpriteIcon('tripp-trapp', {viewBox: TrippTrappSymbol.viewBox})
export const UserFilledIcon = makeSpriteIcon('user-filled', {viewBox: UserFilledSymbol.viewBox})
export const UserIcon = makeSpriteIcon('user-leap', {viewBox: UserSymbol.viewBox})
export const VideoIcon = makeSpriteIcon('video', {viewBox: VideoSymbol.viewBox})
export const WarningIcon = makeSpriteIcon('warning', {
    viewBox: WarningSymbol.viewBox
})
